import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import { MdAdd } from "react-icons/md";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AddDoorStepEmployeeModal from "./AddDoorStepEmployeeModal";
import {
  deleteDoorStepEmployeeApi,
  getDoorStepEmployeeListApi,
} from "../../services/DoorStepEmployeeService";
import { formatToIndianNumber } from "../../utilities";
const DoorStepEmployee = () => {
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || ""
  );
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedData, setSelecetdData] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const handleToggleAddModal = () => {
    if (addModal) {
      setSelecetdData(null);
    }
    setAddModal(!addModal);
  };
  const handleToggleDeleteModal = () => {
    if (deleteModal) {
      setSelecetdData(null);
    }
    setDeleteModal(!deleteModal);
  };

  const getData = () => {
    setLoading(true);
    getDoorStepEmployeeListApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [param]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterEmployeeAdd = () => {
    handleToggleAddModal();
    getData();
  };

  const deleteEmployee = () => {
    setDeleteLoading(true);
    deleteDoorStepEmployeeApi(selectedData?.id || "")
      .then((res) => {
        toast.success("Delete Successfully");
        handleToggleDeleteModal();
        getData();
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  const getValueByKey = (obj, key) => {
    return key
      .split(".")
      .reduce((acc, part) => (acc ? acc[part] : undefined), obj);
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort className="sort-icon neutral" />;
    }
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...data].sort((a, b) => {
      const valA = getValueByKey(a, key);
      const valB = getValueByKey(b, key);

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);
      const dateA = Date.parse(valA);
      const dateB = Date.parse(valB);

      // Numeric sort if both are valid numbers
      if (!isNaN(numA) && !isNaN(numB)) {
        return direction === "asc" ? numA - numB : numB - numA;
      }

      // Date sort if both are valid dates
      if (!isNaN(dateA) && !isNaN(dateB)) {
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Fallback to string sort (letters, "inf", etc.)
      return direction === "asc"
        ? String(valA).localeCompare(String(valB), undefined, {
            sensitivity: "base",
          })
        : String(valB).localeCompare(String(valA), undefined, {
            sensitivity: "base",
          });
    });

    setData(sorted);
  };
  return (
    <div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
          <div className="d-flex gap-1 flex-fill flex-md-grow-0">
            <div className="flex-fill">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
          </div>
          {userRole == "user" && (
            <div>
              <button
                className="btn btn-primary px-2"
                onClick={handleToggleAddModal}
                style={{ padding: "0.45rem 0" }}
              >
                <MdAdd size="20" />
                Door Step Employee
              </button>
            </div>
          )}
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-4 text-danger">{error}</div>
        ) : data && data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th
                    onClick={() => handleSort("name")}
                    style={{ cursor: "pointer" }}
                  >
                    Name{renderSortIcon("name")}
                  </th>
                  <th
                    onClick={() => handleSort("mobile_number")}
                    style={{ cursor: "pointer" }}
                  >
                    Mobile{renderSortIcon("mobile_number")}
                  </th>
                  <th
                    onClick={() => handleSort("designation")}
                    style={{ cursor: "pointer" }}
                  >
                    Designation{renderSortIcon("designation")}
                  </th>
                  <th
                    onClick={() => handleSort("apartment_type")}
                    style={{ cursor: "pointer" }}
                  >
                    Apartment{renderSortIcon("apartment_type")}
                  </th>
                  <th
                    onClick={() => handleSort("fuel_allowance")}
                    style={{ cursor: "pointer" }}
                  >
                    Fuel Allowance{renderSortIcon("fuel_allowance")}
                  </th>
                  <th>Adhaar Image</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>
                      <Link
                        to={`/door-step-employee/${item?.id}`}
                        className="text-primary fw-medium"
                      >
                        {item?.name || "-"}
                      </Link>
                    </td>
                    <td>{item?.mobile_number || "-"}</td>
                    <td>{item?.designation || "-"}</td>
                    <td>{item?.apartment_type || "-"}</td>
                    <td>₹{formatToIndianNumber(item?.fuel_allowance)}</td>
                    <td>
                      {item?.adhar_image ? (
                        <span className="badge text-bg-success-soft">
                          Available
                        </span>
                      ) : (
                        <span className="badge text-bg-danger-soft">
                          Not Available
                        </span>
                      )}
                    </td>
                    <td>
                      <div className="d-flex gap-1 align-self-start">
                        <span
                          className="p-1 btn btn-outline-light ms-1"
                          onClick={() => {
                            setSelecetdData(item);
                            handleToggleAddModal();
                          }}
                        >
                          <FiEdit2 className="text-dark" size="12" />
                        </span>
                        <span
                          className="p-1 btn btn-outline-light ms-1"
                          onClick={() => {
                            setSelecetdData(item);
                            handleToggleDeleteModal();
                          }}
                        >
                          <FiTrash2 className="text-dark" size="12" />
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">No data found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>

      <AddDoorStepEmployeeModal
        data={selectedData}
        visible={addModal}
        onClose={handleToggleAddModal}
        onAfterSubmit={handleAfterEmployeeAdd}
      />

      <Dialog
        maxWidth="xs"
        fullWidth
        open={deleteModal}
        onClose={handleToggleDeleteModal}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>{selectedData?.name}</strong>?
              This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleDeleteModal}
            color="inherit"
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={deleteEmployee}>
            {deleteLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DoorStepEmployee;
